module.exports = __webpack_public_path__ + "img/image-2.9e742e32.jpg";